import React, {
  MouseEvent,
  useCallback,
  useState,
  useRef,
  memo,
  useEffect,
} from 'react';

import { FiChevronDown } from 'react-icons/fi';
import { Link, useHistory } from 'react-router-dom';

import { Container, Options, Title } from './styles';

interface Props {
  title: string;
  urlTitle?: string;
  options: {
    url: string;
    title: string;
  }[];
  colorBase?: string;
  className?: string;
  detail?: boolean;
  closeParentsOnDocument?: boolean;
}

const ButtonWithOptions: React.FC<Props> = ({
  title,
  urlTitle,
  options,
  colorBase: color,
  className,
  detail,
  closeParentsOnDocument,
}) => {
  const optionsRef = useRef<HTMLDivElement>(null);
  const [calculatedHeight, setCalculatedHeight] = useState(0);
  const history = useHistory();

  const handleOpenOption = useCallback(
    (event: MouseEvent<HTMLHeadingElement>) => {
      if (urlTitle) {
        history.push(urlTitle);
      }
      const allInFather = !closeParentsOnDocument
        ? event.currentTarget.parentElement?.parentElement?.querySelectorAll(
            '[data-butttonwithoptions]',
          )
        : document.querySelectorAll('[data-butttonwithoptions]');
      allInFather?.forEach((element) => {
        if (element !== event.currentTarget) {
          element.classList.remove('rotateSvg');
          element.nextElementSibling?.classList.remove('open');
        }
      });
      if (event.currentTarget.nextElementSibling?.classList.contains('open')) {
        event.currentTarget.nextElementSibling.classList.remove('open');
        event.currentTarget.classList.remove('rotateSvg');
      } else {
        event.currentTarget.nextElementSibling?.classList.add('open');
        event.currentTarget.classList.add('rotateSvg');
      }
    },
    [urlTitle, closeParentsOnDocument, history],
  );

  useEffect(() => {
    if (optionsRef.current) {
      setCalculatedHeight(optionsRef.current.scrollHeight);
    }
  }, []);

  return (
    <Container className={className}>
      <Title
        style={{ color, cursor: urlTitle ? 'pointer' : 'default' }}
        onClick={handleOpenOption}
        data-butttonwithoptions
      >
        {title}
        {detail && <p>(PIN-SS)</p>}
        {options.length > 0 && <FiChevronDown size={14} color={color} />}
      </Title>

      <Options
        colorHover={color}
        ref={optionsRef}
        calculatedHeight={calculatedHeight}
      >
        {options.map((option) => (
          <Link
            to={option.url}
            key={`${option.url}-${option.title}`}
            title={option.title}
          >
            {option.title}
          </Link>
        ))}
      </Options>
    </Container>
  );
};

export default memo(ButtonWithOptions);
